import { ReactNode, useEffect, useState } from 'react';
import { FadeInWrapperStyled } from './styled';

type FadeInWrapperProps = {
  children: ReactNode;
};

export const FadeInWrapper = ({ children }: FadeInWrapperProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return <FadeInWrapperStyled isVisible={isVisible}>{children}</FadeInWrapperStyled>;
};
